export const RECRUITMENT_TYPE = {
  NEW: '신입',
  ANY: '무관',
  INTERNSHIP: '인턴',
  CAREER: '경력',
}
